// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DefaultLayout_wrap__khskY","main":"DefaultLayout_main__Ha6WG"};